import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import TrackingAPI from '../api/TrackingAPI';
import { TRACKING_NAME } from '../constants/tracking';

export const useTrackRouteChanges = () => {
  const location = useLocation();
  const prevLocationRef = useRef<null | string>(null);
  const analyticsData = {
    current_url: location.pathname
  };
  useEffect(() => {
    if (prevLocationRef.current === location.pathname) {
      return;
    }

    TrackingAPI.trackEvent(TRACKING_NAME.PAGE_OPENING, analyticsData);
    prevLocationRef.current = location.pathname;
  }, [location.pathname]);
};
